import extendNode from '../extendNode.mjs'
import superMeta from '../_ATTRIBUTE/metaAttributeNode.mjs'
import useAttributeNode from '../_ATTRIBUTE/useAttributeNode.jsx'
import IconQuote from '../icons/icon-quote.svg?react'

export default () => {
    const AttributeNode = useAttributeNode()

    return extendNode(AttributeNode, {
        ...superMeta,
        prop: 'remark',
        type: 'ATTR_PARAM_REMARK',

        getIcons() {
            return [<IconQuote key="type" />]
        },

        getStyle(map, node) {
            return {
                ...AttributeNode.getStyle.call(this, map, node),
                shape: 'Rectangle',
            }
        },
    })
}
